import { useEffect, useRef } from "react";
import { Marker, type Map as MapLibreMap } from "maplibre-gl";
import type { RemoteCursor } from "./tacticalAwareness";

type Props = {
  map: MapLibreMap | null;
  cursors: RemoteCursor[];
};

/**
 * HTML-маркеры курсоров коллег на MapLibre (не путать со стилем фич).
 */
export function TacticalRemoteCursors({ map, cursors }: Props) {
  const markersRef = useRef<Map<number, Marker>>(new Map());

  useEffect(() => {
    if (!map) return;
    const markers = markersRef.current;
    const seen = new Set<number>();

    for (const c of cursors) {
      seen.add(c.clientId);
      let marker = markers.get(c.clientId);
      if (!marker) {
        const el = document.createElement("div");
        el.className = "pointer-events-none";
        el.style.cssText =
          "display:flex;flex-direction:column;align-items:center;transform:translate(-50%,-100%);";
        el.innerHTML = `
          <span style="
            background:${c.color};
            color:#fff;
            font-size:10px;
            line-height:1;
            padding:2px 5px;
            border-radius:4px;
            white-space:nowrap;
            box-shadow:0 1px 2px rgba(0,0,0,.35);
            margin-bottom:2px;
          "></span>
          <span style="
            width:0;height:0;
            border-left:5px solid transparent;
            border-right:5px solid transparent;
            border-top:7px solid ${c.color};
          "></span>`;
        marker = new Marker({ element: el, anchor: "bottom" })
          .setLngLat([c.lng, c.lat])
          .addTo(map);
        markers.set(c.clientId, marker);
      }
      const labelEl = marker.getElement().querySelector("span");
      if (labelEl) labelEl.textContent = c.label;
      marker.setLngLat([c.lng, c.lat]);
    }

    for (const [id, marker] of markers) {
      if (!seen.has(id)) {
        marker.remove();
        markers.delete(id);
      }
    }
  }, [map, cursors]);

  useEffect(() => {
    return () => {
      for (const marker of markersRef.current.values()) {
        marker.remove();
      }
      markersRef.current.clear();
    };
  }, [map]);

  return null;
}
